module.exports = __webpack_public_path__ + "static/img/cgal3.f6a97c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal3.png
// module id = o6k9
// module chunks = 1